import React from "react";
import { useDrag } from "react-dnd";
import { PropTypes } from "prop-types";
import MenuIcon from "@mui/icons-material/Menu";
import CancelIcon from "@mui/icons-material/Cancel";
import style from "./Drop.module.css";

const Drop = ({
  id,
  label,
  isDropped,
  isDroppedLocation,
  onClickHandler = () => {},
  isReassign = false,
  isDraggable = true,
  isPrevSelected = false,
  onDeleteItem = () => {},
}) => {
  const [, drag] = useDrag(() => ({
    type: "string",

    item: { block_master_id: id },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  return (
    <>
      <div
        ref={isDraggable ? drag : null}
        style={{
          height: "fit-content",
          borderRadius: "4px",
          border:
            !isDropped && !isPrevSelected
              ? "1px solid #E8E8E8"
              : "1px solid #E42125",
        }}
      >
        <div
          className={
            isDropped && isPrevSelected
              ? style["main-conatiner_prevSelected_dropStyle"]
              : isDropped && !isPrevSelected
              ? style["main-conatiner_dropStyle"]
              : !isDropped && isPrevSelected
              ? style["main-conatiner_prevSelected"]
              : style["main-conatiner"]
          }
          id={id}
        >
          <div>{label}</div>
          {isDraggable ? (
            <MenuIcon fontSize={"10rem"} sx={{ color: "#E8505B" }} />
          ) : !isPrevSelected ? (
            <CancelIcon
              fontSize={"18rem"}
              sx={{ color: "#E8505B", cursor: "pointer" }}
              onClick={(e) => onDeleteItem(e, id)}
            />
          ) : (
            ""
          )}
        </div>
        <div className={style["label-style"]}>
          {isDropped && isDroppedLocation?.join(",")}
        </div>
      </div>
    </>
  );
};

Drop.propTypes = {
  id: PropTypes.number,
  label: PropTypes.string,
  isDropped: PropTypes.bool,
  isDroppedLocation: PropTypes.string,
  onClickHandler: PropTypes.func,
  forbidDrag: PropTypes.bool,
};

export default Drop;
